import React from 'react';

import { ResumeContentContext } from '../../types';

export const renderBrokerFirstContent = (context: ResumeContentContext) => (
  <div className='resume-content' data-testid="render-broker-first-content">
    <div data-testid="render-broker-first-content-text">
      Their FICO score is {context.steps.ficoRange.element} {`and they've purchased/sold`} {context.steps.propertiesNegotiated.element} {`in the last 36 months`}
    </div>
  </div>
);

export const renderBrokerLastContent = (context: ResumeContentContext) => (
  <div className='resume-content' data-testid="render-broker-last-content">
    <div data-testid="render-broker-last-content-text">This is a {context.steps.loanType.element} for a {context.steps.propertyType.element} {context.steps.loanOwner.element}</div>
  </div>
);

